var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCyberRecovery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.531,
    height: 28.97,
    viewBox: "0 0 32.531 28.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20745",
    "data-name": "Rectangle 20745",
    width: 32.531,
    height: 28.97,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31958",
    "data-name": "Group 31958",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22511",
    "data-name": "Path 22511",
    d: "M11.23,28.97A4.1,4.1,0,0,1,8.32,27.7,3.6,3.6,0,0,1,8,27.36a4.224,4.224,0,0,1,.5-5.94l8.94-8.92a7.234,7.234,0,0,1,1.99-6.73A7.646,7.646,0,0,1,27.8,4.11l1.38.57L25.02,8.86a1.5,1.5,0,0,0-.44,1.07A1.51,1.51,0,0,0,27.16,11l4.18-4.18.58,1.37a7.655,7.655,0,0,1-1.63,8.41,7.263,7.263,0,0,1-6.83,1.92L14.48,27.5a4.685,4.685,0,0,1-3.25,1.47M24.86,5.53A5.674,5.674,0,0,0,20.85,7.2a5.249,5.249,0,0,0-1.33,5.32l.18.58L9.86,22.91a2.234,2.234,0,0,0-.32,3.17c.05.06.12.13.18.19a2.116,2.116,0,0,0,1.52.71,2.668,2.668,0,0,0,1.82-.89l9.84-9.84.59.2a5.254,5.254,0,0,0,5.38-1.26,5.651,5.651,0,0,0,1.62-4.68l-1.91,1.91a3.582,3.582,0,0,1-4.96,0,3.5,3.5,0,0,1,0-4.96L25.5,5.57a4.68,4.68,0,0,0-.64-.04",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22512",
    "data-name": "Path 22512",
    d: "M5.52,22.21h1V7.89H15.79a9.549,9.549,0,0,1,.99-2h1V2.01h11.85a9.615,9.615,0,0,1,6,0h1.48v.57l2,.83V0H0V24.2H5.03a6.315,6.315,0,0,1,.49-1.99",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22513",
    "data-name": "Path 22513",
    d: "M29.33,19.71v2.5h12.58l-2,2H31.33V18.34a9.454,9.454,0,0,1-2,1.37",
    fill: "#444"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberRecovery);
export default __webpack_public_path__ + "static/media/cyber-recovery.51d1aafc4b2a88300f6ef0971ab0c220.svg";
export { ForwardRef as ReactComponent };